import API, { graphqlOperation } from "@aws-amplify/api";
import * as mutations from "../../graphql/mutations";
import * as queries from "../../graphql/queries";
import { makeGraphQLRequest } from "..";
const createBenchmark = async (object) => {
  try {
    return makeGraphQLRequest(
      graphqlOperation(mutations.createBenchmark, { input: object })
    );
  } catch (error) {
    console.error("Error creating Benchmark:", error);
    throw error;
  }
};

const updateBenchmark = async (id, args) => {
  try {
    // First, fetch the current version of the Benchmark
    const getBenchmarkResponse = await makeGraphQLRequest(
      graphqlOperation(queries.getBenchmark, { id })
    );
    const currentBenchmark = getBenchmarkResponse.data.getBenchmark;

    // Prepare the update input
    const updateInput = { id, _version: currentBenchmark._version };
    args.forEach((arg) => {
      updateInput[arg.property] = arg.value;
    });

    return makeGraphQLRequest(
      graphqlOperation(mutations.updateBenchmark, { input: updateInput })
    );
  } catch (error) {
    console.error("Error updating Benchmark:", error);
    throw error;
  }
};

const deleteBenchmark = async (id) => {
  try {
    // First, fetch the current version of the Benchmark
    const getBenchmarkResponse = await makeGraphQLRequest(
      graphqlOperation(queries.getBenchmark, { id })
    );
    const currentBenchmark = getBenchmarkResponse.data.getBenchmark;

    const response = await makeGraphQLRequest(
      graphqlOperation(mutations.deleteBenchmark, {
        input: { id, _version: currentBenchmark._version },
      })
    );
    return response.data.deleteBenchmark;
  } catch (error) {
    console.error("Error deleting Benchmark:", error);
    throw error;
  }
};

const getBenchmarksByWorkspaceID = (workspaceID) =>
  makeGraphQLRequest(
    graphqlOperation(queries.benchmarksByWorkspace, {
      workspaceID: workspaceID,
    })
  );

export default {
  createBenchmark,
  updateBenchmark,
  deleteBenchmark,
  getBenchmarksByWorkspaceID,
};
